<template>
  <BRow>
    <BCol lg="12">
      <div class="text-[24px] text-[#222222] font-semibold mb-[16px]">
        Dashboard
      </div>
      <ringkasan />
      <BCard body>
        <div class="flex items-center justify-between">
          <div class="font-[600] text-[#222222] text-[16px]">
            Performa Pertumbuhan User (Partner)
          </div>
        </div>
        <div class="mt-1 grid grid-cols-1 sm:grid-cols-4 grid-rows-2 gap-4">
          <div class="border border-[#e2e2e2] rounded-2xl  p-1">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <img
                  src="https://storage.googleapis.com/komerce/icon/Icon-regist.svg"
                  alt="Komerce"
                >
                <span class="text-[16px] font-medium text-black ml-[8px]">Registrasi</span>
              </div>
            </div>
            <div
              v-if="loadingCard.registration"
              class="!mt-8 !mb-[52px] flex justify-center"
            >
              <BSpinner
                variant="primary"
              />
            </div>
            <div
              v-else
              class="mt-2 flex justify-center items-center"
            >
              <span class="text-black text-[24px] font-semibold px-[10px]">
                {{ cardData.registration.total }}
              </span>
            </div>
            <div class="mt-[8px]">
              <date-picker
                v-model="registrationPeriod"
                opens="right"
                :date-format="createDatePickerRestrictor((currentDate, endDate) => currentDate >= endDate)"
                :ranges="datepickerRangeGeneral"
                container-class="!w-full"
              >
                <template #default="{ data }">
                  <div class="d-flex align-items-center justify-between w-100">
                    <div class="mr-1">
                      <span>
                        {{ getShortFormattedDateRange(data.startDate, data.endDate) }}
                      </span>
                    </div>
                    <span class="k-calendar text-[24px]" />
                  </div>
                </template>
              </date-picker>
            </div>
            <router-link
              :to="detailRegistrationLink"
              class="mt-[4px] w-auto border-[1px] text-[12px] border-[#F95031] font-medium rounded py-[5px] px-[10px] flex items-center justify-center gap-2 hover:shadow"
            >Lihat Detail<span class="k-arrow-right-3 text-[18px] font-[600] ml-[10px]" />
            </router-link>
          </div>
          <div class="border border-[#e2e2e2] rounded-2xl  p-1">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <img
                  src="https://storage.googleapis.com/komerce/icon/Icon-berlangganan.svg"
                  alt="Komerce"
                >
                <span class="text-[16px] font-medium text-black ml-[8px]">Berlangganan</span>
              </div>
            </div>
            <div
              v-if="loadingCard.subscription"
              class="!mt-8 !mb-[52px] flex justify-center"
            >
              <BSpinner
                variant="primary"
              />
            </div>
            <div v-else>
              <div
                class="mt-2 flex"
              >
                <span class="text-black text-[24px] font-semibold border-r px-[10px]">
                  {{ cardData.subscription.total }}
                </span>
                <div class="ml-1">
                  <div class="text-[#34A270]">
                    + {{ cardData.subscription.current_week }} Minggu Ini
                  </div>
                  <div class="text-[#08A0F7]">
                    + {{ cardData.subscription.previous_week }} Minggu Lalu
                  </div>
                </div>
              </div>
              <div class="flex space-x-2 mt-[12px]">
                <BButton
                  variant="outline-primary"
                  size="sm"
                  @click="$router.push('/history-submission')"
                >
                  {{ cardData.subscription.pending }} pengajuan perlu persetujuan
                </BButton>
              </div>
            </div>
          </div>
          <div class="border border-[#e2e2e2] rounded-2xl  p-1">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <img
                  src="https://storage.googleapis.com/komerce/icon/Icon-inbound.svg"
                  alt="Komerce"
                >
                <span class="text-[16px] font-medium text-black ml-[8px]">Inbound</span>
              </div>
            </div>
            <div
              v-if="loadingCard.inbound"
              class="!mt-8 !mb-[52px] flex justify-center"
            >
              <BSpinner
                variant="primary"
              />
            </div>
            <div
              v-else
              class="mt-2 flex"
            >
              <span class="text-black text-[24px] font-semibold border-r px-[10px]">
                {{ cardData.inbound.total }}
              </span>
              <div class="ml-1">
                <div class="text-[#34A270]">
                  + {{ cardData.inbound.current_week }} Minggu Ini
                </div>
                <div class="text-[#08A0F7]">
                  + {{ cardData.inbound.previous_week }} Minggu Lalu
                </div>
              </div>
            </div>
          </div>
          <div class="border border-[#e2e2e2] rounded-2xl  p-1">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <img
                  src="https://storage.googleapis.com/komerce/icon/Icon-aktifberlanggananan.svg"
                  alt="Komerce"
                >
                <span class="text-[16px] font-medium text-black ml-[8px]">Aktif Berlangganan</span>
              </div>
            </div>
            <div
              v-if="loadingCard.activelySubscribed"
              class="!mt-8 !mb-[52px] flex justify-center"
            >
              <BSpinner
                variant="primary"
              />
            </div>
            <div v-else>
              <div
                class="mt-2 flex justify-center"
              >
                <span class="text-black text-[24px] font-semibold pr-2">
                  {{ cardData.activelySubscribed.total }}
                </span>
              </div>
              <div class="flex mt-[12px] border-[1px] border-[#e2e2e2] rounded-lg">
                <flat-pickr
                  v-model="activePeriod"
                  class="!border-none"
                  :config="flatpickrMonthly"
                />
                <div class="flex items-center justify-center">
                  <span class="k-calendar-2 text-[20px] pr-1 text-[#333333]" />
                </div>
              </div>
            </div>
          </div>
          <div class="border border-[#e2e2e2] rounded-2xl  p-1">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <img
                  src="https://storage.googleapis.com/komerce/icon/Icon-aktif.svg"
                  alt="Komerce"
                >
                <span class="text-[16px] font-medium text-black mx-[8px]">Aktif</span>
                <img
                  id="aktifInfo"
                  class="w-[20px] h-[20px]"
                  src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                  alt="info"
                >
                <BPopover
                  target="aktifInfo"
                  triggers="hover"
                  placement="top"
                >User yang melakukan aktifitas dalam 30 hari terakhir</BPopover>
              </div>
            </div>
            <div
              v-if="loadingCard.active"
              class="!mt-8 !mb-[52px] flex justify-center"
            >
              <BSpinner
                variant="primary"
              />
            </div>
            <div v-else>
              <div
                class="mt-2 text-[#333333]"
              >
                <div class="mb-[8px]">
                  <h3 class="text-base mb-[4px] font-normal">
                    Total pengguna Aktif
                  </h3>
                  <span class="text-lg font-semibold">
                    {{ fallback(cardData.active.total) }}
                  </span>
                </div>
                <div class="flex items-center gap-[8px] flex-wrap">
                  <div class="grow border-r-[1px]">
                    <h3 class="text-base mb-[4px] font-normal">
                      Juragan
                    </h3>
                    <span class="text-lg font-semibold mb-0">
                      {{ fallback(cardData.active.total_user_juragan) }}
                    </span>
                  </div>
                  <div class="grow">
                    <h3 class="text-base mb-[4px] font-normal">
                      Saudagar
                    </h3>
                    <span class="text-lg font-semibold">
                      {{ fallback(cardData.active.total_user_saudagar) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="border border-[#e2e2e2] rounded-2xl  p-1">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <img
                  src="https://storage.googleapis.com/komerce/icon/Icon-inaktif.svg"
                  alt="Komerce"
                >
                <span class="text-[16px] font-medium text-black mx-[8px]">In-aktif</span>
                <img
                  id="inaktifInfo"
                  class="w-[20px] h-[20px]"
                  src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                  alt="info"
                >
                <b-popover
                  target="inaktifInfo"
                  triggers="hover"
                  placement="top"
                >User yang sudah tidak ada transaksi lebih dari 60 hari</b-popover>
              </div>
            </div>
            <div
              v-if="loadingCard.inactive"
              class="!mt-8 !mb-[52px] flex justify-center"
            >
              <BSpinner
                variant="primary"
              />
            </div>
            <div
              v-else
              class="mt-2 flex justify-start"
            >
              <span class="text-black text-[24px] font-semibold px-[10px]">
                {{ cardData.inactive.total }}
              </span>
            </div>
          </div>
          <div class="border border-[#e2e2e2] rounded-2xl  p-1">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <img
                  src="https://storage.googleapis.com/komerce/icon/Icon-pasif.svg"
                  alt="Komerce"
                >
                <span class="text-[16px] font-medium text-black mx-[8px]">Pasif</span>
                <img
                  id="pasifInfo"
                  class="w-[20px] h-[20px]"
                  src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                  alt="info"
                >
                <b-popover
                  target="pasifInfo"
                  triggers="hover"
                  placement="top"
                >User yang sudah tidak ada transaksi selama 60 hari</b-popover>
              </div>
            </div>
            <div
              v-if="loadingCard.passive"
              class="!mt-8 !mb-[52px] flex justify-center"
            >
              <BSpinner
                variant="primary"
              />
            </div>
            <div
              v-else
              class="mt-2 flex justify-start"
            >
              <span class="text-black text-[24px] font-semibold px-[10px]">
                {{ cardData.passive.total }}
              </span>
            </div>
          </div>
          <div class="border border-[#e2e2e2] rounded-2xl  p-1">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <img
                  src="https://storage.googleapis.com/komerce/icon/Icon-jumlahpacking.svg"
                  alt="Komerce"
                >
                <span class="text-[16px] font-medium text-black ml-[8px]">Jumlah Packing</span>
              </div>
            </div>
            <div
              v-if="loadingCard.packing"
              class="!mt-8 !mb-[52px] flex justify-center"
            >
              <BSpinner
                variant="primary"
              />
            </div>
            <div v-else>
              <div class="mt-2 flex">
                <span class="text-black text-[24px] font-semibold border-r px-[10px]">
                  {{ cardData.packing.total }}
                </span>
                <div class="ml-1">
                  <div class="text-[#FBBC05]">
                    Komship : {{ cardData.packing.komship }}
                  </div>
                  <div class="text-[#08A0F7]">
                    Non-Komship : {{ cardData.packing.nonKomship }}
                  </div>
                  <div class="text-[#808080]">
                    Marketplace : {{ cardData.packing.marketplace }}
                  </div>
                </div>
              </div>
              <div class="flex mt-[12px] border-[1px] border-[#e2e2e2] rounded-lg">
                <flat-pickr
                  v-model="packingPeriod"
                  :config="flatpickrMonthly"
                  class="!border-none"
                />
                <div class="flex items-center justify-center">
                  <span class="k-calendar-2 text-[20px] pr-1 text-[#333333]" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </BCard>
      <BCard body>
        <low-moving-stock />
        <grafik-tren-request />
      </BCard>
    </BCol>
  </BRow>
</template>
<script>
import { newAxiosIns } from '@/libs/axios'
import ToastificationContentVue from '@/@core/components/toastification/ToastificationContent.vue'
import {
  last7, today, last2, last30,
} from '@/store/helpers'
import {
  LABELDAY, LABELMONTH, YEAR_MONTH_DAY, createDatePickerRestrictor,
} from '@/libs/filterDate'
import MonthSelect from 'flatpickr/dist/plugins/monthSelect'
import flatPickr from 'vue-flatpickr-component'
import { Indonesian } from 'flatpickr/dist/l10n/id'
import '@/@core/scss/vue/libs/vue-flatpicker.scss'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import { datePickerRangeGeneral } from '../config'
import { getShortFormattedDateRange } from '../helpers'
import Ringkasan from './Ringkasan.vue'
import GrafikTrenRequest from './GrafikTrenRequest.vue'
import LowMovingStock from './LowMovingStock.vue'
import DatePicker from '../DatePicker.vue'

export default {
  components: {
    flatPickr,
    Ringkasan,
    GrafikTrenRequest,
    LowMovingStock,
    DatePicker,
  },
  data() {
    return {
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: LABELDAY,
        monthNames: LABELMONTH,
      },
      registrationPeriod: {
        startDate: this.$route.query.rs ? new Date(this.$route.query.rs) : last30,
        endDate: this.$route.query.re ? new Date(this.$route.query.re) : last2,
      },

      flatpickrMonthly: {
        mode: 'single',
        locale: Indonesian,
        altInput: true,
        maxDate: today,
        plugins: [
          new MonthSelect({
            shorthand: true,
            dateFormat: 'Y-m-d',
            altFormat: 'M Y',
          }),
        ],
      },

      loadingCard: {
        registration: false,
        subscription: false,
        inbound: false,
        activelySubscribed: false,
        active: false,
        inactive: false,
        passive: false,
        packing: false,
      },

      cardData: {
        registration: {
          total: 0,
        },
        subscription: {
          total: 0,
          current_week: 0,
          previous_week: 0,
          pending: 0,
        },
        inbound: {
          total: 0,
          current_week: 0,
          previous_week: 0,
        },
        activelySubscribed: {
          total: 0,
        },
        active: {
          total: 0,
          current_week: 0,
          previous_week: 0,
          current_month: 0,
          previous_month: 0,
        },
        inactive: {
          total: 0,
        },
        passive: {
          total: 0,
        },
        packing: {
          total: 0,
          komship: 0,
          nonKomship: 0,
          marketplace: 0,
        },
      },

      activePeriod: YEAR_MONTH_DAY(today),
      packingPeriod: YEAR_MONTH_DAY(today),
    }
  },
  computed: {
    detailRegistrationLink() {
      return `/kompack-daftar-partner?start_date=${YEAR_MONTH_DAY(this.registrationPeriod.startDate)}&end_date=${YEAR_MONTH_DAY(this.registrationPeriod.endDate)}`
    },
  },
  watch: {
    activePeriod: {
      handler() {
        this.getActivelySubscribed()
      },
    },
    registrationPeriod: {
      handler() {
        this.getTotalRegister()
        this.updatePeriodQuery()
      },
    },
    packingPeriod: {
      handler() {
        this.getPacking()
      },
    },
  },
  created() {
    // Card Data
    this.getTotalRegister()
    this.getTotalSubscription()
    this.getTotalInbounds()
    this.getTotalActive()
    this.getTotalInactive()
    this.getTotalPassive()
    this.getActivelySubscribed()
    this.getPacking()
    this.datepickerRangeGeneral = datePickerRangeGeneral(last2)
  },
  methods: {
    createDatePickerRestrictor,
    getShortFormattedDateRange,
    /**
     * Update periode di URL query parameters untuk mempertahankan state saat reload
     */
    updatePeriodQuery() {
      this.$router.push({
        query: {
          ...this.$route.query,
          rs: YEAR_MONTH_DAY(this.registrationPeriod.startDate),
          re: YEAR_MONTH_DAY(this.registrationPeriod.endDate),
        },
      })
    },
    // Card Data
    async getTotalRegister() {
      this.loadingCard.registration = true
      const url = '/auth/api/v1/admin/dashboard/total-register/kompack'
      await newAxiosIns.get(url, { params: { start_date: YEAR_MONTH_DAY(this.registrationPeriod.startDate), end_date: YEAR_MONTH_DAY(this.registrationPeriod.endDate) } })
        .then(res => {
          const { data } = res.data
          this.cardData.registration.total = data.total
          this.loadingCard.registration = false
        })
        .catch(err => {
          this.loadingCard.registration = false
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: 'Failure',
              icon: 'AlertCircleIcon',
              text: 'Gagal mengambil data, refresh halaman ini',
              variant: 'danger',
            },
          }, { timeout: 2000 })
        })
    },
    async getTotalSubscription() {
      this.loadingCard.subscription = true
      const url = 'komship/api/v1/admin/subscribe-warehouses/total-subscriptions'
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.cardData.subscription.total = data.total
          this.cardData.subscription.current_week = data.current_week
          this.cardData.subscription.previous_week = data.previous_week
          this.cardData.subscription.pending = data.pending
          this.loadingCard.subscription = false
        })
        .catch(err => {
          this.loadingCard.subscription = false
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: 'Failure',
              icon: 'AlertCircleIcon',
              text: 'Gagal mengambil data, refresh halaman ini',
              variant: 'danger',
            },
          }, { timeout: 2000 })
        })
    },
    async getTotalInbounds() {
      this.loadingCard.inbound = true
      const url = 'komship/api/v1/admin/inbounds/total-inbounds'
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.cardData.inbound.total = data.total
          this.cardData.inbound.current_week = data.current_week
          this.cardData.inbound.previous_week = data.previous_week
          this.loadingCard.inbound = false
        })
        .catch(err => {
          this.loadingCard.inbound = false
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: 'Failure',
              icon: 'AlertCircleIcon',
              text: 'Gagal mengambil data, refresh halaman ini',
              variant: 'danger',
            },
          }, { timeout: 2000 })
        })
    },
    async getTotalActive() {
      this.loadingCard.active = true
      const url = '/kompack/api/v1/dashboard/admin/statistics/users/active'
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.cardData.active = data
          this.loadingCard.active = false
        })
        .catch(err => {
          this.loadingCard.active = false
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: 'Failure',
              icon: 'AlertCircleIcon',
              text: 'Gagal mengambil data, refresh halaman ini',
              variant: 'danger',
            },
          }, { timeout: 2000 })
        })
    },
    async getTotalInactive() {
      this.loadingCard.inactive = true
      const url = '/kompack/api/v1/dashboard/admin/statistics/users/inactive'
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.cardData.inactive.total = data.total
          this.loadingCard.inactive = false
        })
        .catch(err => {
          this.loadingCard.inactive = false
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: 'Failure',
              icon: 'AlertCircleIcon',
              text: 'Gagal mengambil data, refresh halaman ini',
              variant: 'danger',
            },
          }, { timeout: 2000 })
        })
    },
    async getTotalPassive() {
      this.loadingCard.passive = true
      const url = '/kompack/api/v1/dashboard/admin/statistics/users/passive'
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.cardData.passive.total = data.total
          this.loadingCard.passive = false
        })
        .catch(err => {
          this.loadingCard.passive = false
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: 'Failure',
              icon: 'AlertCircleIcon',
              text: 'Gagal mengambil data, refresh halaman ini',
              variant: 'danger',
            },
          }, { timeout: 2000 })
        })
    },
    async getActivelySubscribed() {
      this.loadingCard.activelySubscribed = true
      const url = 'kompack/api/v1/dashboard/admin/statistics/active-subscriptions'
      const params = {
        period: this.activePeriod,
      }
      await newAxiosIns.get(url, { params })
        .then(res => {
          const { data } = res.data
          this.cardData.activelySubscribed.total = data.total
          this.loadingCard.activelySubscribed = false
        })
        .catch(err => {
          this.loadingCard.activelySubscribed = false
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: 'Failure',
              icon: 'AlertCircleIcon',
              text: 'Gagal mengambil data, refresh halaman ini',
              variant: 'danger',
            },
          }, { timeout: 2000 })
        })
    },
    async getPacking() {
      this.loadingCard.packing = true
      const url = '/kompack/api/v1/dashboard/admin/statistics/packing-requests'
      const params = {
        period: this.packingPeriod,
      }
      await newAxiosIns.get(url, { params })
        .then(res => {
          const { data } = res.data
          this.cardData.packing.total = data.total
          this.cardData.packing.komship = data.komship
          this.cardData.packing.nonKomship = data.non_komship
          this.cardData.packing.marketplace = data.marketplace
          this.loadingCard.packing = false
        })
        .catch(err => {
          this.loadingCard.packing = false
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: 'Failure',
              icon: 'AlertCircleIcon',
              text: 'Gagal mengambil data, refresh halaman ini',
              variant: 'danger',
            },
          }, { timeout: 2000 })
        })
    },
    /**
     * Fallback to a default value if the given value is null or undefined.
     *
     * @param {*} value - The value to check.
     * @param {*} [fallbackValue='-'] - The fallback value to use.
     * @returns {*} The original value if not null or undefined, otherwise the fallback value.
     */
    fallback(value, fallbackValue = '-') {
      return value ?? fallbackValue
    },
  },
}
</script>

<style>
.flatpickr-monthSelect-month.selected{
  background-color: #F95031 !important;
}
.flatpickr-monthSelect-month{
    font-weight: 600 !important;
}
.flatpickr-current-month input.cur-year{
    font-weight: 600 !important;
}
</style>
